import React from "react";
import {Box, Typography} from "@mui/material";
import ContactFormSkeleton from "@/components/forms/contact-form-section/contact-form.skeleton";
import HubspotEmbed from "@/components/forms/hubspot-embed";
import {ContactFormSection} from "@/types/dto/destinations-page/destination-page-types";
import useHubspotEmbed from "@/hooks/forms/use-hubspot-embed";
import HubspotFormDisclaimer from "@/components/forms/disclaimer/hubspot-form-disclaimer";

interface ContactFormProps {
  contactFormSection: ContactFormSection;
}

const ContactForm = ({
  contactFormSection
}: ContactFormProps) => {

  const { dataLayerProps, isLoading, targetId } = useHubspotEmbed({
    formId: contactFormSection.contactForm.formId,
    portalId: contactFormSection.contactForm.portalId,
    formName: contactFormSection.contactForm.formName
  });

  return (
    <Box>
      <Typography
        variant="h6"
        component="h3"
        sx={{
          color: "text.primary",
          paddingBottom: "2.4rem",
          fontSize: "1.8rem !important",
          fontWeight: "600 !important"
        }}
      >
        {contactFormSection.contactForm.formTitle}
      </Typography>
      <Box
        sx={{
          width: "100%",
          display: isLoading ? "auto" : "none"
        }}
      >
        <ContactFormSkeleton/>
      </Box>
      <Box
        sx={{
          opacity: isLoading ? 0 : 1,
          transition: "opacity 0.5s ease-in"
        }}
      >
        <HubspotEmbed
          formId={contactFormSection.contactForm.formId}
          dataLayerProps={dataLayerProps}
          targetId={targetId}
          data-testid="contactform-hubspot-embed"
        />
      </Box>
      <HubspotFormDisclaimer testId="contact-form-disclaimer" />
    </Box>
  );
};

export default ContactForm;